import * as R from 'ramda'
import { getDaysInMonth, setDate, setMonth, setYear } from 'date-fns'

/**
 * Create an array of complete or partial selection of dates of a month
 * @param {Date} min Minimum date range.
 * @param {Date} max Maximum date range.
 * @param {Date} current Current position of range.
 * @returns {array} Array of numbers in ascending order representing dates.
 */
export function getDateRange(min, max, current) {
  const maxYear = max.getFullYear()
  const maxMonth = max.getMonth()
  const maxDay = max.getDate()
  const currentYear = current.getFullYear()
  const currentMonth = current.getMonth()
  const minYear = min.getFullYear()
  const minMonth = min.getMonth()
  const minDay = min.getDate()

  if (
    (currentYear === maxYear && currentMonth >= maxMonth) ||
    currentYear > maxYear
  ) {
    return R.range(1, maxDay + 1)
  }

  if (
    (currentYear === minYear && currentMonth <= minMonth) ||
    currentYear < minYear
  ) {
    return R.range(minDay, getDaysInMonth(new Date(minYear, minMonth)) + 1)
  }

  return R.range(1, getDaysInMonth(new Date(currentYear, currentMonth)) + 1)
}

/**
 * Create an array of complete or partial selection of months
 * @param {Date} min  Minimum date range.
 * @param {Date} max  Maximum date range.
 * @param {Date} current Current position of range.
 * @returns {array} Array of numbers in ascending order representing months.
 */
export function getMonthRange(min, max, current) {
  const maxYear = max.getFullYear()
  const maxMonth = max.getMonth()
  const currentYear = current.getFullYear()
  const minYear = min.getFullYear()
  const minMonth = min.getMonth()

  if (currentYear >= maxYear) {
    return R.range(0, maxMonth + 1)
  }

  if (currentYear <= minYear) {
    return R.range(minMonth, 12)
  }

  return R.range(0, 12)
}

/**
 * Create an array of years
 * @param {Date} min Timestamp to constraint year range from.
 * @param {Date} max Timestamp to constraint year range to.
 * @returns {array} Array of numbers in ascending order representing years.
 */
export function getYearRange(min, max) {
  const maxYear = max.getFullYear()
  const minYear = min.getFullYear()

  return R.reverse(R.range(minYear, maxYear + 1))
}

/**
 * Generate a new timestamp
 * @param {string} unit="year"|"month"|"day" Target date unit to update.
 * @param {number} timestamp Timestamp to base update on.
 * @param {number} value Value of target unit.
 * @returns {number} Timestamp.
 */
export function getNextDate(unit, timestamp, value) {
  const MODIFIERS = {
    day: setDate,
    month: setMonth,
    year: setYear,
  }
  const modifier = MODIFIERS[unit] || R.identity
  const prevDate = new Date(timestamp)
  const nextDate = modifier(prevDate, value)

  return nextDate
}
